class PaymentHistoryService {
  constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
  }
  
  getPaymentState(documentNumber, payNumber, typeDocument) {

    let data = JSON.stringify({nro_docto: payNumber,id_tipo_docto: typeDocument,Id_Cliente: documentNumber});
    
    var body = new FormData();         
    body.append('formData', data);
    
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri  + this.ngAuthSettings.config.paths.REPORTS.SYNC.PAYMENT_HISTORY.DETAIL,
        data: body,
        transformRequest: angular.identity,    
        headers: { 'Content-Type': undefined },
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getPaymentStates(documentNumber, numberDays=30, dateFilter=0, dateStart='null', dateEnding='null') {
    return this.$q((resolve, reject) => { 

      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.PAYMENT_HISTORY.LIST +
        '?codigoProveedor='+documentNumber+
        '&numeroDias='+numberDays+
        '&filtroFechas='+dateFilter+
        '&fechaDesde='+dateStart+
        '&fechaHasta='+dateEnding+'' ,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
  
  getExportExcel(payments,nameClient, initDate, endDate, aplyDateFilter){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.PAYMENT_HISTORY.EXPORT_EXCEL,
        data : {
          'payments' : payments,
          'client': nameClient,
          'initDate': initDate, 
          'endDate': endDate, 
          'aplyDateFilter': aplyDateFilter
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getExportPdf(payments,nameClient, initDate, endDate, aplyDateFilter){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.PAYMENT_HISTORY.EXPORT_PDF,
        data : {
          'payments' : payments,
          'client': nameClient,
          'initDate': initDate, 
          'endDate': endDate, 
          'aplyDateFilter': aplyDateFilter
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', 
          'Accept': 'application/pdf'
        },
        cache : false,
        responseType: "blob"
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getExportDetailExcel(payment, payments,nameClient){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.PAYMENT_HISTORY.EXPORTDETAIL_EXCEL,
        data : {
          'payment' : payment,
          'payments' : payments,
          'client': nameClient
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getExportDetailPdf(payment, payments,nameClient){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.REPORTS.SYNC.PAYMENT_HISTORY.EXPORTDETAIL_PDF,
        data : {
          'payment' : payment,
          'payments' : payments,
          'client': nameClient
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', 
          'Accept': 'application/pdf'
        },
        cache : false,
        responseType: "blob"
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

}

PaymentHistoryService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default PaymentHistoryService;



/** WEBPACK FOOTER **
 ** ./www/components/reports/payment-history/payment-history.service.js
 **/